<template>
  <v-container>
    <v-row justify="center">
      <v-img
        class="img-profile"
        width="128"
        height="128"
        max-width="128"
        max-height="128"
        src="../assets/penguin.svg"
      ></v-img>
    </v-row>  
    <v-row justify="center">
      <h2>tomosibi</h2>
    </v-row>
    <v-row justify="center">
      <h3>about</h3>
    </v-row>
    <v-row justify="center">
      <v-card
        class="about-card"
        :width="cardWidth"
      >
        <v-row>
          <v-col class="about-header" cols="5">          
            <span class="about-icon"><v-icon color="amber lighten-3">mdi-cards-heart</v-icon></span>
            Age
          </v-col>
          <v-col>{{age}}</v-col>
        </v-row>
        <v-row>
          <v-col class="about-header" cols="5">
            <span class="about-icon"><v-icon color="amber lighten-3">mdi-home-account</v-icon></span>
            Residence
          </v-col>
          <v-col>福岡</v-col>
        </v-row>
        <v-row>
          <v-col class="about-header" cols="5">
            <span class="about-icon"><v-icon color="amber lighten-3">mdi-laptop</v-icon></span>
            Job
          </v-col>
          <v-col>プログラマ</v-col>
        </v-row>
      </v-card>
    </v-row>
    <v-row justify="center">
      <h3>Career</h3>
    </v-row>
    <v-row justify="center">
      <v-card
        class="career-card"
        :width="cardWidth"
      >
        <v-timeline
          class="time-line"
          align-top
          dense
        >
          <!-- 2018 -->
          <v-timeline-item
            color="teal"
          >
            <v-row align="center">
              <v-col class="time-line-year" cols="4">
                <strong>2018</strong>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item
            color="teal lighten-5"
            small
          >
            <v-row>
              <v-col class="time-line-month" cols="3">
                10月
              </v-col>
              <v-col class="career-desc">
                <v-icon>mdi-school</v-icon>
                ITスクール入学(社会人向け)
              </v-col>
            </v-row>
          </v-timeline-item>
          <!-- 2019 -->
          <v-timeline-item
            color="pink"
          >
            <v-row align="center">
              <v-col class="time-line-year" cols="4">
                <strong>2019</strong>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item
            color="pink lighten-5"
            small
          >
            <v-row>
              <v-col class="time-line-month" cols="3">
                <pre> 9月</pre>
              </v-col>
              <v-col class="career-desc">
                <v-icon>mdi-school</v-icon>
                ITスクールを卒業
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item
            color="pink lighten-5"
            small
          >
            <v-row>
              <v-col class="time-line-month" cols="3">
                10月
              </v-col>
              <v-col class="career-desc">
                <v-icon>mdi-office-building-outline</v-icon>
                黒目の組込SES企業に入社
              </v-col>
            </v-row>
          </v-timeline-item>
          <!-- 2020 -->
          <v-timeline-item
            color="amber"
          >
            <v-row align="center" class="pt-1">
              <v-col class="time-line-year" cols="4">
                <strong>2020</strong>
              </v-col>
            </v-row>
          </v-timeline-item>
          <!-- 2021 -->
          <v-timeline-item
            color="cyan"
          >
            <v-row align="center" class="pt-1">
              <v-col class="time-line-year" cols="4">
                <strong>2021</strong>
              </v-col>
            </v-row>
          </v-timeline-item>
          <!-- 2022 -->
          <v-timeline-item
            color="teal"
          >
            <v-row align="center" class="pt-1">
              <v-col class="time-line-year" cols="4">
                <strong>2022</strong>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item
            color="teal lighten-5"
            small
          >
            <v-row>
              <v-col class="time-line-month" cols="3">
                3月
              </v-col>
              <v-col class="career-desc">
                <v-icon>mdi-office-building-outline</v-icon>
                受託系Web開発企業に転職
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-card>
    </v-row>
    <v-row justify="center">
      <h3>License</h3>
    </v-row>
    <v-row justify="center">
      <v-card
        class="license-card"
        outlined
        :width="cardWidth"
      >
        <v-row>
          <v-list>
            <v-list-item
              v-for="(item, index) in this.licenses"
              :key="index"
              ripple
            >
              <span class="star">
                <v-icon color="amber lighten-3">mdi-star</v-icon>
              </span>
              <v-list-item-content>
                <span class="license-name">{{item}}</span>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-row>
      </v-card>
    </v-row>
  </v-container>
</template>

<style scoped>
  /* v-cardのデフォルトのマージン値を修正 */
  .about-card, .career-card{
    margin-top: 5px !important;
    margin-bottom: 20px !important;
  }
  /* 資格名の色を変更 */
  .license-name{
    color: #707070;
  }
  /* 資格欄横のスペースを開ける */
  .star{
    margin-left: -2px;
    margin-right: 5px;
  }
  h3{
    color: white;
    text-shadow: 1px 1px 1px #808080;   
  }
  h2{
    color: white;
    text-shadow: 1px 2px 3px #808080;
  }
  .img-profile{
    margin-top: 20px;
    background-color: white;
    box-shadow: 0 0 0 5px #fab300;
    border-radius: 100%;
    will-change: transform;
  }
  /* プロフ画像のバウンスアニメーションを定義 */
  .img-profile:hover {
    -webkit-animation: bounceOut 0.4s linear;
            animation: bounceOut 0.4s linear;
  }
  @-webkit-keyframes bounceOut {
    0% {
      box-shadow: 0 0 0 4px #fab300;
      opacity: 1;
      transform: scale(1);
    }
    25% {
      box-shadow: 0 0 0 1px #fab300;
      opacity: 1;
      transform: scale(0.97);
    }
    50% {
      box-shadow: 0 0 0 7px #fab300;
      opacity: 1;
      transform: scale(1.01);
    }
    75% {
      box-shadow: 0 0 0 4px #fab300;
      opacity: 1;
      transform: scale(1);
    }
    100% {
      box-shadow: 0 0 0 5px #fab300;
      opacity: 1;
    }
  }
  @keyframes bounceOut {
    0% {
      box-shadow: 0 0 0 4px #fab300;
      opacity: 1;
      transform: scale(1);
    }
    25% {
      box-shadow: 0 0 0 1px #fab300;
      opacity: 1;
      transform: scale(0.97);
    }
    50% {
      box-shadow: 0 0 0 7px #fab300;
      opacity: 1;
      transform: scale(1.01);
    }
    75% {
      box-shadow: 0 0 0 4px #fab300;
      opacity: 1;
      transform: scale(1);
    }
    100% {
      box-shadow: 0 0 0 5px #fab300;
      opacity: 1;
    }
  }
  /* about内項目のオフセット */
  .about-header{
    margin-left: 5px;
  }
  .about-icon{
    margin-right: 5px;
  }
  /* career内項目のオフセット */
  .time-line{
    margin-left: -10px;
  }
  .time-line-year{
    margin-left: -30px;
  }
  .time-line-month{
    margin-left: -25px;
  }
  .career-desc{
    margin-left: -20px;
  }
</style>

<script>
// import moment from 'moment';
  export default {
    name: 'Profile',
    data: () => ({
      licenses:[
        'ORACLE MASTER Silver SQL 2019',
        'ORACLE MASTER Silver DBA 2019',
        'Java Programmer Silver SE 11',
        'AWS Certified Solutions Architect – Associate',
        'AWS Certified Cloud Practitioner',
        '猫検定 初級',
        '基本情報技術者試験',
        'ITパスポート',
        '第一種普通自動車免許',
      ],
      cardWidth: 360,
      age: 28,
    }),
    created(){
      // 年齢計算
      const birthday = new Date(1992, 10, 18); // monthは0~11
      const today = new Date();
      this.age = today.getFullYear() - birthday.getFullYear();
      if(today.getMonth() <= birthday.getMonth()){
        if(today.getMonth() == birthday.getMonth()){
          if(today.getDate() < birthday.getDate()){
            // 誕生月かつ誕生日がまだ訪れていない場合
            this.age--;
          }
        }else{
          // 誕生月がまだ訪れていない場合
          this.age--;
        }
      }
    }
  }
</script>
